/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    InputTypeDTO,
    InputTypeDTOFromJSON,
    InputTypeDTOToJSON,
} from '../models';

/**
 * 
 */
export class InputTypeControllerApi extends runtime.BaseAPI {

    /**
     */
    async listInputTypesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InputTypeDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/inputTypes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InputTypeDTOFromJSON));
    }

    /**
     */
    async listInputTypes(initOverrides?: RequestInit): Promise<Array<InputTypeDTO>> {
        const response = await this.listInputTypesRaw(initOverrides);
        return await response.value();
    }

}
